import { SvgIconComponent } from '@mui/icons-material'
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'
import { Theme } from '@mui/material/styles'

import { EtaSource } from 'generated/graphql'

export interface IEtaSourceMeta {
  label: string
  description: string
  Icon: SvgIconComponent
  getColor: (theme: Theme) => string
}

export const getEtaSourceMeta = (
  source: EtaSource | null | undefined,
  hasValue = false,
): IEtaSourceMeta => {
  switch (source) {
    case EtaSource.DriverProvided:
      return {
        label: 'Driver ETA',
        description: 'Submitted by the driver or an operator, including auto-calculated ETAs',
        Icon: PersonOutlinedIcon,
        getColor: (theme) => theme.palette.primary.main,
      }
    case EtaSource.Google:
      return {
        label: 'Google ETA',
        description: "Live travel time from the driver's current location",
        Icon: MyLocationOutlinedIcon,
        getColor: (theme) => theme.palette.info.dark,
      }
    case EtaSource.Calculated:
      return {
        label: 'Calculated ETA',
        description: 'Travel time from the previous stop, updated at each milestone',
        Icon: RouteOutlinedIcon,
        getColor: (theme) => theme.palette.warning.dark,
      }
    case EtaSource.WecAi:
      return {
        label: 'WecAi ETA',
        description: 'Reported by the driver during a WecAi call',
        Icon: SupportAgentOutlinedIcon,
        getColor: (theme) => theme.palette.success.dark,
      }
    default:
      return {
        label: 'No ETA Available',
        description: hasValue
          ? 'No driver, Google or calculated ETA yet. The booked time slot is shown instead.'
          : 'No live ETA has been provided or calculated for this stop',
        Icon: EventAvailableOutlinedIcon,
        getColor: (theme) => theme.palette.text.disabled,
      }
  }
}
